import React, { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';
import Close from '@zocdoc-frontend-common/assets-icons/Close';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { blue100, white } from '@zocdoc-mezzanine/foundations-colors';
import { paragraphSmall } from '@zocdoc-mezzanine/foundations-typography';
import { isLegacyBrowser } from './browserUtils';

const BrowserSupportBanner = (props) => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const isLegacy = props.__forceLegacyBanner || isLegacyBrowser;
        setShowBanner(isLegacy);
    }, [props.__forceLegacyBanner]);

    const onClose = useCallback(() => {
        setShowBanner(false);
    }, []);

    // hitting spacebar when focused on close icon should close banner
    const handleKeyDownCloseIcon = useCallback(
        (e) => {
            if (e.key === ' ') {
                e.preventDefault();
                onClose();
            }
        },
        [onClose]
    );

    return (
        showBanner && (
            <Banner data-test="legacy-browser-banner">
                Zocdoc no longer supports Internet Explorer. We recommend using
                another browser like Chrome, Firefox or Safari.
                <CloseWrapper
                    aria-label="Close"
                    data-test="legacy-browser-banner-close-icon"
                    onClick={onClose}
                    onKeyDown={handleKeyDownCloseIcon}
                    role="button"
                    tabIndex={0}
                >
                    <Close color={white} />
                </CloseWrapper>
            </Banner>
        )
    );
};

const Banner = styled.div`
    ${paragraphSmall}
    background-color: ${blue100};
    color: ${white};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 60px 14px 16px;

    ${breakpoint.small} {
        padding: 12px 32px 12px 12px;
    }
`;

const CloseWrapper = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 12px;
    cursor: pointer;

    ${breakpoint.small} {
        right: 24px;
    }
`;

export default BrowserSupportBanner;
